import { render, staticRenderFns } from "./ItemsTab.vue?vue&type=template&id=899808ec&scoped=true&"
import script from "./ItemsTab.vue?vue&type=script&lang=js&"
export * from "./ItemsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899808ec",
  null
  
)

export default component.exports